import { SxProps, Theme } from "@mui/material";

import { theme } from "@/src/theme/theme";

import { CarouselArrowDirection } from "./homePageImageCarousel.constants";

export const SECTION_BACKGROUND = theme.palette.semantic.secondary.hover;

export const sectionSx: SxProps<Theme> = {
  background: SECTION_BACKGROUND
};

export const carouselWrapperSx: SxProps<Theme> = {
  mt: 2,
  position: "relative",
  px: { xs: 0, sm: 5 },
  // Constrain carousel width on tablet-sized viewports (matches the
  // tablet breakpoint range in homePageImageCarousel.constants.ts: 900-1374px)
  maxWidth: { xs: "100%", md: "800px", lg: "100%" },
  mx: "auto",
  "& .react-multiple-carousel__arrow": {
    display: "none"
  }
};

export const cardSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  alignItems: "stretch",
  flex: "1 1 100%",
  minWidth: 0,
  width: "100%",
  // Figma spec: 360 x 270 card (4:3) with 16/16/8/16 padding and 40px radius.
  maxWidth: "360px",
  aspectRatio: "360 / 270",
  padding: theme.spacing(2, 2, 1, 2),
  gap: 1.25,
  borderRadius: "40px",
  boxSizing: "border-box",
  mx: "auto"
};

const arrowBaseSx: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  width: { xs: "36px", sm: "40px" },
  height: { xs: "36px", sm: "40px" },
  backgroundColor: theme.palette.semantic.secondary.main,
  color: theme.palette.semantic.secondary.contrastText,
  zIndex: 2,
  "&:hover": {
    backgroundColor: theme.palette.semantic.secondary.main
  }
};

export const buildArrowSx = (
  direction: CarouselArrowDirection
): SxProps<Theme> => ({
  ...arrowBaseSx,
  // Push arrows farther from center on tablet viewports where the
  // carousel wrapper is narrowed (see carouselWrapperSx maxWidth).
  ...(direction === "left"
    ? { left: { xs: "12px", md: "-28px", lg: "12px" } }
    : { right: { xs: "12px", md: "-28px", lg: "12px" } })
});
